// The only layers the SPA can draw. A manifest id without a module here is skipped (design D3);
// a module here without a manifest entry is never added.

import ausNoise from "./aus-noise";
import coaFloodplain from "./coa-floodplain-atlas14";
import coaJurisdictions from "./coa-jurisdictions";
import coaParks from "./coa-parks";
import coaTrails from "./coa-trails";
import coaWui from "./coa-wui";
import coaZoning from "./coa-zoning";
import edwardsContributing from "./edwards-contributing";
import edwardsRecharge from "./edwards-recharge";
import femaNfhl from "./fema-nfhl";
import isdBoundaries from "./isd-boundaries";
import txgioFootprints from "./txgio-footprints";
import type { LayerStyle } from "./types";

// Draw order, bottom to top: broad areas first, lines and buildings last.
const ORDER: LayerStyle[] = [
  edwardsContributing,
  edwardsRecharge,
  coaJurisdictions,
  isdBoundaries,
  coaZoning,
  coaWui,
  coaParks,
  femaNfhl,
  coaFloodplain,
  ausNoise,
  coaTrails,
  txgioFootprints,
];

export const STYLES: ReadonlyMap<string, LayerStyle> = new Map(ORDER.map((s) => [s.id, s]));
export type { LayerStyle } from "./types";
